import Entity from "lib/models/Entity";
import { computed } from "mobx";

export interface CreatorSource {
  id: number;
  username: string;
  email: string;
}

export default class Creator extends Entity<CreatorSource> {
  @computed
  get username(): string {
    return this.source.username;
  }

  @computed
  get email(): string {
    return this.source.email;
  }
}
